// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterToggleGroup } from '@/components/filter-toggle-group';
import { ProjectViewMode } from '@/constants/project-view-mode';
import { PROJECT_VIEW_MODE_OPTIONS } from '@/project/constants/view-mode-options';

interface Props {
  /**
   * The currently selected view mode.
   */
  value: ProjectViewMode;

  /**
   * A callback fired when the view mode is changed.
   */
  onChange: (viewMode: ProjectViewMode) => void;
}

/**
 * A toggle button group for switching between project view modes.
 */
export function ProjectViewModeToggle(props: Props) {
  return (
    <FilterToggleGroup
      value={props.value}
      options={PROJECT_VIEW_MODE_OPTIONS}
      onChange={props.onChange}
      ariaLabel="Project view mode"
    />
  );
}
